"use client";

import React from "react";
const partners = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/partner_logo_microsoft.png",
  alt: "Microsoft Certified Partner"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/partner_logo_comptia.png",
  alt: "CompTIA Authorized"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/partner_logo_valley_bank.png",
  alt: "Rapid City Bank"
}, {
  id: 4,
  src: "https://sycomp.com/wp-content/uploads/2024/09/20-1.jpg",
  alt: "Palo Alto"
}, {
  id: 5,
  src: "https://shopdoubleradius.com/cdn/shop/collections/UniFi.png?v=1732121449&width=950",
  alt: "Unifi Systems"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/partner_logo_fortinet.png",
  alt: "Fortinet Security"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/partner_logo_rapid_logistics.png",
  alt: "Rapid Logistics"
}];
export default function IndustryCollaborations() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="224939" id="trusted-by-local-businesses" className="relative py-24 bg-background text-foreground overflow-hidden border-y border-border/40">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-infinite {
          animation: marquee-scroll 40s linear infinite;
          width: max-content;
        }
      `}</style>

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] opacity-10 pointer-events-none [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]" />

      {}
      <div className="absolute top-6 left-6 w-8 h-8 border-t border-l border-primary/40 pointer-events-none" />
      <div className="absolute bottom-6 right-6 w-8 h-8 border-b border-r border-secondary/40 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-sm font-mono tracking-widest text-secondary uppercase font-semibold">
            Using the industries finest
          </h2>
        </div>

        {}
        <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div className="flex items-center gap-16 animate-marquee-infinite hover:[animation-play-state:paused] pr-16">
            {marqueeItems.map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="flex-shrink-0 flex items-center justify-center w-40 h-20">
                <img src={partner.src} alt={partner.alt} className="max-w-full max-h-full object-contain grayscale opacity-50 transition-all duration-500 ease-in-out hover:grayscale-0 hover:opacity-100 hover:scale-105 cursor-pointer" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}